import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'

import NotificationBanner from '@/components/common/NotificationBanner.vue'
import TableWithStickyHeader, {
  TableColumn,
} from '@/components/common/TableWithStickyHeader.vue'
import i18n from '@/i18n'
import { useAveragesStore } from '@/store/public/averages'
import { formatFloat, formatValue } from '@/utils/format'


export default /*@__PURE__*/_defineComponent({
  __name: 'AverageSearchResults',
  setup(__props) {

const averages = useAveragesStore()

const tableColumns = computed<TableColumn[]>((): TableColumn[] => [
  { label: i18n.global.t('averages.name'), type: 'any' },
  { label: i18n.global.t('averages.club'), type: 'any' },
  { label: i18n.global.t('averages.klass'), type: 'value' },
  { label: i18n.global.t('averages.average'), type: 'value' },
  { label: i18n.global.t('averages.basis'), type: 'value-wide' },
  { label: i18n.global.t('averages.previous'), type: 'value-wide' },
  { label: i18n.global.t('averages.cut-score-games'), type: 'value-wide' },
  { label: i18n.global.t('averages.season-games'), type: 'value-wide' },
  { label: i18n.global.t('averages.age-group'), type: 'value' },
])

const tableData = computed<string[][]>((): string[][] =>
  (averages.results ?? []).map((result) => [
    formatValue(result.bowler.full_name),
    formatValue(result.bowler.club),
    formatValue(result.bowler.klass),
    formatFloat(result.values.current_average, 2),
    formatFloat(result.values.average_basis, 0),
    formatFloat(result.values.previous_average, 2),
    formatFloat(result.values.season_cut_score_game_count, 0),
    formatFloat(result.values.season_game_count, 0),
    formatValue(result.bowler.age_group),
  ]),
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(averages).results?.length === 0)
      ? (_openBlock(), _createBlock(NotificationBanner, {
          key: 0,
          message: _ctx.$t('averages.no-results')
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    (_unref(averages).results?.length > 0)
      ? (_openBlock(), _createBlock(TableWithStickyHeader, {
          key: 1,
          columns: tableColumns.value,
          data: tableData.value
        }, null, 8, ["columns", "data"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})